var _rect, _path, _path2, _path3, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatAutomate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#E7F8FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2938_3049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 105,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9495 38H71.6122C73.2691 38 74.6122 39.3431 74.6122 41V60.3258V76.1633C74.6122 78.9247 72.3737 81.1633 69.6122 81.1633H61.3462H45C43.3431 81.1633 42 79.8201 42 78.1633V47.9226M51.9495 38L42 47.9226M51.9495 38V45.9226C51.9495 47.0272 51.0541 47.9226 49.9495 47.9226H42",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4081 62.2442V43.8775C79.4081 42.2207 78.065 40.8775 76.4081 40.8775H74.6122V76.1633C74.6122 78.9247 72.3736 81.1633 69.6122 81.1633H46.7959V82C46.7959 83.6568 48.139 85 49.7959 85H74.4081C77.1696 85 79.4081 82.7614 79.4081 80V62.2442Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7621 64.2787H61.1759C60.9659 64.2787 60.7645 64.3622 60.6161 64.5106C60.4676 64.6591 60.3842 64.8604 60.3842 65.0704C60.3842 65.2804 60.4676 65.4817 60.6161 65.6302C60.7645 65.7787 60.9659 65.8621 61.1759 65.8621H63.0759C62.2026 66.7747 61.0764 67.4053 59.842 67.6729C58.6076 67.9406 57.3214 67.833 56.1486 67.3641C54.9758 66.8951 53.97 66.0862 53.2605 65.0413C52.5509 63.9963 52.17 62.7631 52.1667 61.5C52.1667 61.29 52.0833 61.0887 51.9348 60.9402C51.7864 60.7917 51.585 60.7083 51.375 60.7083C51.1651 60.7083 50.9637 60.7917 50.8152 60.9402C50.6668 61.0887 50.5834 61.29 50.5834 61.5C50.5876 63.046 51.0443 64.5569 51.8972 65.8463C52.7502 67.1357 53.9619 68.1471 55.383 68.7558C56.8041 69.3645 58.3724 69.5438 59.8942 69.2715C61.416 68.9992 62.8248 68.2874 63.9467 67.2237V68.625C63.9467 68.835 64.0301 69.0363 64.1786 69.1848C64.327 69.3333 64.5284 69.4167 64.7384 69.4167C64.9483 69.4167 65.1497 69.3333 65.2982 69.1848C65.4466 69.0363 65.53 68.835 65.53 68.625V65.0625C65.5281 64.858 65.447 64.6621 65.3039 64.516C65.1607 64.3699 64.9666 64.2849 64.7621 64.2787ZM58.5 53.5833C56.4705 53.5891 54.5207 54.3741 53.0534 55.7762V54.375C53.0534 54.165 52.97 53.9637 52.8215 53.8152C52.673 53.6667 52.4717 53.5833 52.2617 53.5833C52.0517 53.5833 51.8504 53.6667 51.7019 53.8152C51.5534 53.9637 51.47 54.165 51.47 54.375V57.9375C51.47 58.1475 51.5534 58.3488 51.7019 58.4973C51.8504 58.6458 52.0517 58.7292 52.2617 58.7292H55.8242C56.0342 58.7292 56.2355 58.6458 56.384 58.4973C56.5325 58.3488 56.6159 58.1475 56.6159 57.9375C56.6159 57.7275 56.5325 57.5262 56.384 57.3777C56.2355 57.2292 56.0342 57.1458 55.8242 57.1458H53.9242C54.797 56.2337 55.9224 55.6033 57.1561 55.3354C58.3898 55.0675 59.6753 55.1744 60.8478 55.6423C62.0203 56.1103 63.0262 56.918 63.7363 57.9617C64.4465 59.0054 64.8285 60.2376 64.8334 61.5C64.8334 61.71 64.9168 61.9113 65.0652 62.0598C65.2137 62.2083 65.4151 62.2917 65.625 62.2917C65.835 62.2917 66.0364 62.2083 66.1848 62.0598C66.3333 61.9113 66.4167 61.71 66.4167 61.5C66.4167 60.4604 66.2119 59.4309 65.8141 58.4704C65.4162 57.5099 64.8331 56.6372 64.098 55.9021C63.3628 55.1669 62.4901 54.5838 61.5296 54.1859C60.5691 53.7881 59.5397 53.5833 58.5 53.5833Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 103.5,
    height: 103.5,
    rx: 51.75,
    stroke: "#0078BB",
    strokeWidth: 1.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2938_3049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 60.5C113 89.4949 89.4949 113 60.5 113C31.5051 113 8 89.4949 8 60.5C8 31.5051 31.5051 8 60.5 8C89.4949 8 113 31.5051 113 60.5Z",
    fill: "url(#paint0_linear_2938_3049)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2938_3049",
    x1: 61,
    y1: -12,
    x2: 60.5,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F4F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatAutomate);
export default __webpack_public_path__ + "static/media/feat_automate.5479f0fc6a0b44d4c6ddb07fb66ba4ba.svg";
export { ForwardRef as ReactComponent };